<template>
    <div class="record-accountinglot">
        <PageTitle icon="fa fa-exchange" main="Registro" sub="Lote Contábil" />
        <b-form>
            <b-row>
                <input
                    id="accountinglot-id"
                    type="hidden"
                    v-model="accountinglot.id"
                />
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Data do Lote:"
                        label-for="accountinglot-accountinglot_date"
                    >
                        <b-form-input
                            id="accountinglot-accountinglot_date"
                            type="date"
                            ref="inputsearch"
                            v-model="accountinglot.accountinglot_date"
                            :readonly="docRead"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Nº Ref.:"
                        label-for="accountinglot-accountinglot_number"
                    >
                        <b-form-input
                            id="accountinglot-accountinglot_number"
                            v-model="accountinglot.accountinglot_number"
                            :readonly="docRead"
                            type="number"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Status:"
                        label-for="accountinglot-accountinglot_status_id"
                    >
                        <b-form-select
                            id="accountinglot-accountinglot_status_id"
                            size="sm"
                            disabled
                            :options="documentstatus"
                            v-model="accountinglot.accountinglot_status_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    v-show="!docRead"
                    class="fa fa-save"
                    @click="saveAccountingLot"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="ml-2 fa fa-reply"
                    @click="goback"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="ml-2"
                    v-if="
                        this.accountinglot.accountinglot_status_id === 1 &&
                            accountinglot.id > 0
                    "
                    @click=";[confirmAccountingLot()]"
                    >Confirmar</b-button
                >
            </b-col>
        </b-row>
        <hr />
        <b-card bg-variant="light" text-variant="dark">
            <b-tabs pills card small>
                <b-tab title="Lançamento(s)" active>
                    <b-row>
                        <b-col md="2" sm="12">
                            <b-button
                                title="Adicionar Lançamento"
                                size="sm"
                                @click="setNewRelease"
                                v-b-modal.modalAccountingLotRelease
                                v-show="
                                    this.accountinglot
                                        .accountinglot_status_id === 1 &&
                                    this.accountinglot.id > 0
                                        ? true
                                        : false
                                "
                                variant="light"
                                class="mr-2 mb-2 fa fa-plus"
                            >
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12">
                            <transition name="slide" type="animation" appear>
                                <b-table
                                    class="table-responsive"
                                    hover
                                    key="slide"
                                    head-variant="light"
                                    :items="accountinglotsreleases"
                                    :fields="fieldsAccountingLotRelease"
                                >
                                    <template v-slot:cell(actions)="data">
                                        <b-button
                                            title="Editar registro"
                                            v-show="!docRead"
                                            v-b-modal.modalAccountingLotRelease
                                            size="sm"
                                            variant="light"
                                            @click="
                                                loadAccountingLotsRelease(
                                                    data.item
                                                )
                                            "
                                            class="mr-2 mt-2 fa fa-pencil"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            v-show="!docRead"
                                            variant="light"
                                            @click="modeRelease = 'remove'"
                                            class="mr-2 mt-2 fa fa-trash"
                                            v-if="modeRelease === 'insert'"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="
                                                ;[
                                                    removeRelease(data.item),
                                                    (modeRelease = 'insert')
                                                ]
                                            "
                                            class="mr-2 mt-2 fa fa-check"
                                            v-if="modeRelease === 'remove'"
                                        >
                                        </b-button>
                                        <b-button
                                            size="sm"
                                            variant="light"
                                            @click="modeRelease = 'insert'"
                                            class="mr-2 mt-2 fa fa-times"
                                            v-if="modeRelease === 'remove'"
                                        >
                                        </b-button>
                                        <span
                                            class="mr-2 mt-2"
                                            v-if="modeRelease === 'remove'"
                                        >
                                            Deseja Excluir o registro?
                                        </span>
                                    </template>
                                </b-table>
                            </transition>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-card>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
        <b-modal
            id="modalAccountingLotRelease"
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Lançamento(s)"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveRelease"
        >
            <b-form>
                <b-row>
                    <b-col md="2" sm="12">
                        <b-form-group label="Natureza da Conta">
                            <b-form-radio-group
                                v-model="accountinglotsrelease.credit"
                                :options="options_account"
                                name="accountinglotsrelease-credit"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" sm="12">
                        <b-form-group
                            label="Conta Contábil:"
                            label-for="accountinglotsrelease-account_plan_id"
                        >
                            <b-form-select
                                id="accountinglotsrelease-account_plan_id"
                                size="sm"
                                :options="accountplans"
                                v-model="accountinglotsrelease.account_plan_id"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="2" sm="2">
                        <b-form-group label="ID" label-for="entity-id">
                            <b-form-input
                                id="entity-id"
                                type="text"
                                v-model="accountinglotsrelease.entity_id"
                                @input="
                                    setEntity(accountinglotsrelease.entity_id)
                                "
                                @change="
                                    setEntity(accountinglotsrelease.entity_id)
                                "
                                v-on:keyup.alt.enter="openModalEntity"
                                size="sm"
                                placeholder="Código..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-link v-b-modal.modalEntity class="fa fa-search mt-4">
                    </b-link>
                    <b-col md="5" sm="8">
                        <b-form-group
                            label="Nome/Razão Social:"
                            label-for="entity-name_entity"
                        >
                            <b-form-input
                                id="entity-name_entity"
                                type="text"
                                v-model="entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ:"
                            label-for="entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entity-cnpj_cpf"
                                type="text"
                                v-model="entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        v-b-modal.modalRegisterEntity
                        class="fa fa-plus mt-4"
                    >
                    </b-link>
                </b-row>
                <b-row>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="accountinglotsrelease-release_value"
                        >
                            <b-form-input
                                id="accountinglotsrelease-release_value"
                                v-model="accountinglotsrelease.release_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="7" sm="12">
                        <b-form-group
                            label="Histórico:"
                            label-for="accountinglotsrelease-historic"
                        >
                            <b-form-textarea
                                id="accountinglotsrelease-historic"
                                :rows="2"
                                :max-rows="3"
                                size="sm"
                                v-model="accountinglotsrelease.historic"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="8" sm="12">
                        <b-form-group
                            label="Centro de Resultado:"
                            label-for="accountinglotsrelease-cost_center_id"
                        >
                            <b-form-select
                                id="accountinglotsrelease-cost_center_id"
                                size="sm"
                                :options="costcenters"
                                v-model="accountinglotsrelease.cost_center_id"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Operação:"
                            label-for="accountinglotsrelease-operation_id"
                        >
                            <b-form-select
                                id="accountinglotsrelease-operation_id"
                                @input="loadOperationsLevelOnes"
                                size="sm"
                                :options="operations"
                                v-model="accountinglotsrelease.operation_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="1º Nível:"
                            label-for="accountinglotsrelease-operation_level_one_id"
                        >
                            <b-form-select
                                id="accountinglotsrelease-operation_level_one_id"
                                @input="loadOperationsLevelTwos"
                                size="sm"
                                :options="operationslevelones"
                                v-model="
                                    accountinglotsrelease.operation_level_one_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="2º Nível:"
                            label-for="accountinglotsrelease-operation_level_two_id"
                        >
                            <b-form-select
                                id="accountinglotsrelease-operation_level_two_id"
                                size="sm"
                                :options="operationsleveltwos"
                                v-model="
                                    accountinglotsrelease.operation_level_two_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl, showError } from '@/global'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
import axios from 'axios'
var moment = require('moment')

export default {
    name: 'RecordAccountingLot',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'save',
            modeRelease: 'insert',
            docRead: false,
            showRelease: false,
            showEntity: false,
            entity_id: null,
            search: '',
            searchEntity: '',
            documentstatus: [],
            accountinglot: {},
            accountinglotsrelease: {},
            accountinglotsreleases: [],
            entity: {},
            entitys: [],
            accountplans: [],
            costcenters: [],
            operations: [],
            operationsleveltwos: [],
            operationslevelones: [],
            typecosts: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            perPage: 5,
            currentPage: 1,
            fieldsAccountingLotRelease: [
                {
                    key: 'internal_code_account_plan',
                    label: 'Conta',
                    sortable: true
                },
                {
                    key: 'name_account_plan',
                    label: 'Descrição',
                    sortable: true
                },
                {
                    key: 'credit',
                    label: 'Crédito',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                {
                    key: 'release_value',
                    label: 'Valor',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'name_operation',
                    label: 'Operação',
                    sortable: false
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Resultado',
                    sortable: false
                },
                {
                    key: 'name_entity',
                    label: 'Razão Social',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            options_account: [
                { text: 'Crédito', value: 1 },
                { text: 'Débito', value: 0 }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredList() {
            return this.entitys.filter(entity => {
                return (
                    entity.name_entity
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase()) ||
                    entity.cnpj_cpf
                        .toLowerCase()
                        .includes(this.searchEntity.toLowerCase())
                )
            })
        },
        rows() {
            return this.entitys.length
        }
    },
    methods: {
        goback() {
            this.$router.go(-1, { query: 'q=s', hash: 'hashFrag' })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        loadEntitys() {
            const url = `${baseApiUrl}/entitys`
            axios.get(url).then(res => {
                this.entitys = res.data
            })
        },
        async loadAccountingLotsReleases() {
            const id = this.accountinglot.id
            const url = `${baseApiUrl}/accountinglotsreleases/${id}/accountinglot`
            await axios.get(url).then(res => {
                this.accountinglotsreleases = res.data
            })
        },
        async saveAccountingLot() {
            if (this.accountinglot.id) {
                this.accountinglot.user_update_id = this.user.id
                this.accountinglot.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.accountinglot.user_id = this.user.id
                if (!this.compan) {
                    this.$toasted.global
                        .defaultError({ msg: 'Logar na Empresa' })
                        .catch(showError)
                } else {
                    this.accountinglot.accountinglot_company_id = this.compan.id
                }
            }
            const method = this.accountinglot.id ? 'put' : 'post'
            const id = this.accountinglot.id ? `/${this.accountinglot.id}` : ''
            await axios[method](
                `${baseApiUrl}/accountinglots${id}`,
                this.accountinglot
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.getLastAccountingLot()
                    await this.loadAccountingLot()
                })
                .catch(showError)
        },
        async getLastAccountingLot() {
            const url = `${baseApiUrl}/accountinglotidlast/${this.accountinglot.accountinglot_company_id}/?user_id=${this.accountinglot.user_id}/&accountinglot_date=${this.accountinglot.accountinglot_date}`
            await axios(url).then(res => (this.accountinglot.id = res.data.id))
        },
        async confirmAccountingLot() {
            if (!this.compan.accounting_period_start) {
                this.$toasted.global.defaultError({
                    msg: 'Empresa sem definição de Período Contábil'
                })
            } else {
                if (
                    this.formatDate(this.compan.accounting_period_start) >
                    this.formatDate(this.accountinglot.accountinglot_date)
                ) {
                    this.$toasted.global.defaultError({
                        msg: 'Data esta fora do período contábil'
                    })
                } else if (
                    this.formatDate(this.compan.accounting_period_end) <
                    this.formatDate(this.accountinglot.accountinglot_date)
                ) {
                    this.$toasted.global.defaultError({
                        msg: 'Data esta fora do período contábil'
                    })
                } else {
                    if (this.accountinglot.id) {
                        if (this.accountinglot.accountinglot_status_id === 2) {
                            this.accountinglot.accountinglot_status_id = 1
                            this.docRead = false
                        } else {
                            this.accountinglot.accountinglot_status_id = 2
                            this.docRead = true
                        }

                        const method = this.accountinglot.id ? 'put' : 'post'
                        const id = this.accountinglot.id
                            ? `/${this.accountinglot.id}`
                            : ''
                        await axios[method](
                            `${baseApiUrl}/accountinglots${id}`,
                            this.accountinglot
                        )
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                if (
                                    this.accountinglot
                                        .accountinglot_status_id === 2
                                ) {
                                    this.goback()
                                }
                            })
                            .catch(showError)
                        this.accountinglot.accountinglot_status_id = 1
                        this.docRead = false
                    }
                }
            }
        },
        async saveRelease() {
            this.accountinglotsrelease.user_id = this.user.id

            const method = this.accountinglotsrelease.id ? 'put' : 'post'
            const id = this.accountinglotsrelease.id
                ? `/${this.accountinglotsrelease.id}`
                : ''
            this.accountinglotsrelease.accounting_lot_id = this.accountinglot.id
            this.accountinglotsrelease.company_id = this.accountinglot.accountinglot_company_id
            await axios[method](
                `${baseApiUrl}/accountinglotsreleases${id}`,
                this.accountinglotsrelease
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    this.accountinglotsrelease = {}
                    await this.loadAccountingLotsReleases()
                })
                .catch(showError)
        },
        async removeRelease(accountinglotsrelease) {
            const id = accountinglotsrelease.id
            await axios
                .delete(`${baseApiUrl}/accountinglotsreleases/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadAccountingLotsReleases()
                })
                .catch(showError)
        },
        async setEntity(entity) {
            if (!this.accountinglotsrelease.entity_id) {
                this.accountinglotsrelease.entity_id = entity.id
            }
            const url = `${baseApiUrl}/entitys/${this.accountinglotsrelease.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        setSearchEntity() {
            this.accountinglotsrelease = {
                ...this.accountinglotsrelease,
                entity_id: this.entity_id
            }
        },
        async loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            await axios.get(url).then(res => {
                this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                })
            })
            this.$refs.inputsearch.focus()
        },
        async loadCostCenter() {
            if (this.compan) {
                const url = `${baseApiUrl}/costcenteranalitic/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.costcenters = res.data.map(costcenter => {
                        return {
                            value: costcenter.id,
                            text: costcenter.name_cost_center
                        }
                    })
                })
            }
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status
                    }
                })
            })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.accountinglotsrelease.operation_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.accountinglotsrelease.operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        setNewRelease() {
            this.accountinglotsrelease = {}
            this.entity = {}
            this.loadOperationsLevelOnes()
        },
        loadAccountPlan() {
            const url = `${baseApiUrl}/accountplananalitic`
            axios.get(url).then(res => {
                this.accountplans = res.data.map(accountplan => {
                    return {
                        value: accountplan.id,
                        text: `${accountplan.internal_code_account_plan} - ${accountplan.name_account_plan} `
                    }
                })
            })
        },
        loadAccountingLotsRelease(release) {
            this.accountinglotsrelease = { ...release }
            this.entity.name_entity = this.accountinglotsrelease.name_entity
            this.entity.cnpj_cpf = this.accountinglotsrelease.cnpj_cpf
        },
        async loadAccountingLot() {
            const url = `${baseApiUrl}/accountinglots/${this.accountinglot.id}`
            await axios.get(url).then(res => {
                this.accountinglot = { ...res.data }
                this.accountinglot.direct_release_date = this.formatDate(
                    this.accountinglot.direct_release_date
                )
                this.accountinglot.direct_settlement_date = this.formatDate(
                    this.accountinglot.direct_settlement_date
                )
            })
        },

        hideModal() {
            this.$bvModal.hide('modalEntity')
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        }
    },
    watch: {
        $route(to) {
            //this.accountinglot = to.params
            this.accountinglot = to.query.accountinglotbase

            //this.loadAccountingLotbase()
        }
    },
    async mounted() {
        if (!this.$route.query.accountinglotbase) {
            this.accountinglot.id = this.$route.params.id
            await this.loadAccountingLot()
        } else {
            this.accountinglot = this.$route.query.accountinglotbase
            this.docRead =
                this.accountinglot.accountinglot_status_id === 1 ? false : true
        }

        if (!this.accountinglot.accountinglot_date) {
            this.accountinglot.accountinglot_date = moment
                .utc()
                .local()
                .format('YYYY-MM-DD')
        }

        this.loadTypeCost()
        this.loadCostCenter()
        this.loadOperation()
        this.loadAccountingLotsReleases()
        this.loadDocumentStaus()
        this.loadOperationsLevelOnes()
        this.loadAccountPlan()
    }
}
</script>

<style>
.record-accountinglot select,
label {
    font-size: 0.7rem;
}
.record-accountinglot input {
    font-size: 0.7rem;
}
.record-accountinglot button {
    font-size: 0.7rem;
}
.record-accountinglot h6 {
    font-size: 0.7rem;
}

#modalAccountingLotRelease select,
label {
    font-size: 0.7rem;
}

#modalAccountingLotRelease input {
    font-size: 0.7rem;
}

#modalAccountingLotRelease textarea {
    font-size: 0.7rem;
}

#modalAccountingLotRelease button {
    font-size: 0.7rem;
}

#modalAccountingLotApportionment select,
label {
    font-size: 0.7rem;
}

#modalAccountingLotApportionment input {
    font-size: 0.7rem;
}

#modalAccountingLotApportionment button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
